import { makeStyles } from '@material-ui/core';

export const SubDescriptionStyle = makeStyles({
    root: {
        paddingLeft: '20px',
    },
});
